import { observer } from 'mobx-react-lite';

import { Icons } from '@/assets/icons/icons';
import { IconButton, Text } from '@/components/ui';
import { XStack, YStack } from '@/components/ui/layout/layout';
import { useHashRoute } from '@/hooks/useHashRoute';
import { cn } from '@/lib/utils';

import { useRoutineCreditShare } from './hooks/use-credit-usage';

type RoutineCreditShareRowProps = {
  routineId: number;
  isQuickAgent: boolean;
};

export const RoutineCreditShareRow = observer(
  ({ routineId, isQuickAgent }: RoutineCreditShareRowProps) => {
    const { setHash } = useHashRoute();
    const { sharePct, runCount, isHeavy, hasAllowance } =
      useRoutineCreditShare(routineId);

    if (!hasAllowance) return null;

    const suggestQuick = isHeavy && !isQuickAgent;
    const runs =
      runCount === 0
        ? 'No runs this cycle'
        : `${runCount} ${runCount === 1 ? 'run' : 'runs'} this cycle`;

    return (
      <XStack className="items-center justify-between gap-3">
        <YStack className="min-w-0 gap-0.5">
          <XStack className="items-center gap-0">
            <Text className="text-sm font-medium">Usage</Text>
            <IconButton
              size="xs"
              className="-mt-[0.5px]"
              icon={Icons.squareArrowOutUpRight}
              tooltip="See all usage"
              aria-label="See all usage"
              onClick={() => setHash('settings/Usage')}
            />
          </XStack>
          <Text className="text-xs leading-5 text-foreground-muted">
            {runs}
            {suggestQuick && ' · Quick mode would use less'}
          </Text>
        </YStack>
        <Text
          className={cn(
            'shrink-0 text-xs tabular-nums',
            isHeavy ? 'text-warning-11' : 'text-foreground-muted'
          )}
        >
          {sharePct}% of monthly usage
        </Text>
      </XStack>
    );
  }
);
